module.exports = __webpack_public_path__ + "static/media/MK_dark.91c95ce4.png";